import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";
import { FaInstagram, FaTiktok, FaPinterest } from "react-icons/fa";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="footer-container">
      <div className="footer-top">
        <div className="footer-column">
          <h3 className="footer-title">Shop</h3>
          <ul className="footer-list">
            <li>
              <Link to="/shop" className="footer-link" onClick={toTop}>
                All Products
              </Link>
            </li>
            <li>
              <Link to="/shop" className="footer-link" onClick={toTop}>
                New Arrivals
              </Link>
            </li>
            <li>
              <Link to="/shop" className="footer-link" onClick={toTop}>
                Best Sellers
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h3 className="footer-title">Support</h3>
          <ul className="footer-list">
            <li>
              <Link to="/about" className="footer-link" onClick={toTop}>
                Our Story
              </Link>
            </li>
            <li>
              <Link to="/contact" className="footer-link" onClick={toTop}>
                Contact Us
              </Link>
            </li>
            <li>
              <Link to="/shipping" className="footer-link" onClick={toTop}>
                Shipping Policy
              </Link>
            </li>
            <li>
              <Link to="/returns" className="footer-link" onClick={toTop}>
                Returns & Exchanges
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-column newsletter">
          <h3 className="footer-title">Connect</h3>
          <p>
            Matthew Pham
            <br />
            ptqckynhm4635@outlook.com
            <br />
            3294 mt Logan Dr
            <br />
            San jose
            <br />
            95127
            <br />
            United States of America
            <br />
            California
            <br />
            Call us: +1 6362646173
          </p>
        </div>
        <div className="footer-column social">
          <h3 className="footer-title">Follow Us</h3>
          <div className="social-icons">
            <FaInstagram className="social-icon" />
            <FaTiktok className="social-icon" />
            <FaPinterest className="social-icon" />
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p className="copyright">
          &copy; 2026 Liiskerlane. All rights reserved.
        </p>
        <div className="footer-legal">
          <Link to="/privacy" className="footer-legal-link" onClick={toTop}>
            Privacy Policy
          </Link>
          <Link to="/terms" className="footer-legal-link" onClick={toTop}>
            Terms of Service
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
